import React from 'react';
import './home.css'

import CardQuizFeed from '../../components/CardQuizFeed'

const Home = () => {
    return (
        <div className="home">
            <CardQuizFeed/>
        </div>
    );
}

export default Home;